
/**
 * DTO Response.
 */
export class ModelResponseDTO<T> {

    hasNext: boolean;
    items: T[];
    length: number;
    totvs_messages: any[];
    _messages: any[];

    constructor() {};
}